// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-action[data-v-0c5999f6]{padding-top:3em}.task-action .action[data-v-0c5999f6]{padding-top:1em}", ""]);
// Exports
module.exports = exports;
